import { CountByMonth } from './count-by-month.type';
import { getDataPoints } from './get-data-points';

export interface StackedBarField {
  sourceField: string;
  targetField: string;
}

export interface StackedBarOptions {
  dateField: string;
  fields: StackedBarField[];
  year: number;
  periods?: string[];
  locale?: string;
}

export const convertToStackedBarData = <T extends Record<string, any>>(
  data: T[],
  options: StackedBarOptions,
) => {
  const allPeriods = options.periods || [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
  ];

  const processedFields = options.fields.map((field) => {
    const fieldData: CountByMonth[] = data.map((item) => ({
      month:
        typeof item[options.dateField] === 'string'
          ? new Date(item[options.dateField])
          : item[options.dateField],
      count: item[field.sourceField] || 0,
    }));

    return {
      field,
      points: getDataPoints(fieldData, 1, options.year)[0] || [],
    };
  });

  // Create output data structure with zero values for all periods
  const periodMap: Record<string, Record<string, any>> = {};

  allPeriods.forEach((period) => {
    // Initialize period entry
    periodMap[period] = { [options.dateField]: period };

    // Initialize all fields with zeros
    options.fields.forEach((field) => {
      periodMap[period][field.targetField] = 0;
    });
  });

  // Fill in data points for each field
  processedFields.forEach(({ field, points }) => {
    points.forEach((point) => {
      if (point && typeof point.x === 'string') {
        periodMap[point.x][field.targetField] = Number(point.y) || 0;
      }
    });
  });

  return allPeriods.map((period) => periodMap[period]);
};
